import React from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { Department } from '../../types';

interface DepartmentSelectorProps {
  departments: Department[];
  selectedDepartmentId: number | null;
  onDepartmentChange: (departmentId: number | null) => void;
  disabled?: boolean;
}

export const DepartmentSelector: React.FC<DepartmentSelectorProps> = ({
  departments,
  selectedDepartmentId,
  onDepartmentChange,
  disabled = false,
}) => {
  const handleChange = (event: any, newValue: any) => {
    const selectedDepartment = departments[newValue];
    onDepartmentChange(selectedDepartment?.id || null);
  };

  // Find the index of the selected department
  const selectedIndex = departments.findIndex(
    (dept) => dept.id === selectedDepartmentId,
  );
  const tabValue = selectedIndex >= 0 ? selectedIndex : 0;

  if (departments.length <= 1) {
    return null; // Don't show tabs if there's only one or no departments
  }

  return (
    <Box sx={{ width: '100%', mb: 2 }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={tabValue}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile>
          {departments.map((department, index) => (
            <Tab
              key={department.id}
              label={department.name}
              id={`department-tab-${index}`}
              aria-controls={`department-tabpanel-${index}`}
              data-testid={`department-tab-${department.name}`}
            />
          ))}
        </Tabs>
      </Box>
    </Box>
  );
};
